import { useState } from 'react';
import type { ChatMessage, Citation } from '@/Public/ChatBot/Types';

interface AddMessageInput {
    readonly role: ChatMessage['role'];
    readonly content: string;
    readonly citations?: readonly Citation[];
    readonly answerable?: boolean;
}

interface UseChatHistoryReturn {
    readonly messages: readonly ChatMessage[];
    readonly addMessage: (input: AddMessageInput) => string;
    readonly setFeedback: (messageId: string, direction: 'up' | 'down') => void;
    readonly clearHistory: () => void;
}

export function useChatHistory(): UseChatHistoryReturn {
    const [messages, setMessages] = useState<ChatMessage[]>([]);

    const addMessage = (input: AddMessageInput): string => {
        const id = crypto.randomUUID();
        const message: ChatMessage = {
            id,
            role: input.role,
            content: input.content,
            timestamp: new Date(),
            citations: input.citations,
            answerable: input.answerable,
        };
        setMessages((prev) => [...prev, message]);
        return id;
    };

    const setFeedback = (messageId: string, direction: 'up' | 'down'): void => {
        setMessages((prev) =>
            prev.map((msg) =>
                msg.id === messageId ? { ...msg, feedback: direction } : msg,
            ),
        );
    };

    const clearHistory = (): void => {
        setMessages([]);
    };

    return { messages, addMessage, setFeedback, clearHistory };
}
